module.exports = __webpack_public_path__ + "static/media/logo-parisandco_black.d9c647b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/logo-parisandco_black.png
// module id = 1847
// module chunks = 0